import {Component, Input, ElementRef, ViewChild, Renderer2} from '@angular/core';
import {FileUploader} from "ng2-file-upload";
import {UploadService} from "../upload.service";
import {ToastService} from "../../../core/toast.service";
import {environment} from "../../../config/environment";
import {AppAuth} from "../../../core/auth";
import {AlertController} from "ionic-angular";
import {TranslateService} from "@ngx-translate/core";
import {Job} from "../../../../pages/job/shared/job.model";
import {JobService} from "../../../../pages/job/shared/job.service";

@Component({
  selector: 'app-job-attachments',
  templateUrl: 'job-attachments.component.html',
})
export class JobAttachmentsComponent {

  public uploader: FileUploader;
  @Input() job: Job;
  @ViewChild('uploadInput') uploadElRef: ElementRef;
  @ViewChild('progressBar') progressBarElRef: ElementRef;

  constructor(
    private auth: AppAuth,
    private uploadService: UploadService,
    private toast: ToastService,
    private alertCtrl: AlertController,
    private translate: TranslateService,
    private jobService: JobService,
    private renderer: Renderer2
  ) {

    this.uploader = new FileUploader({
      url: environment.API + '/upload/file',
    });

    this.auth.getAuthStatus()
      .subscribe((token) => {
        this.auth.getToken().then(token => {
            this.uploader.authToken = token ? 'Bearer ' + token : null;
        });
      });

    this.uploader.onAfterAddingFile = (item) => {
      item.withCredentials = false;
      item.upload();

      // Clear input file selection, so you could select the same file if needed
      this.uploadElRef.nativeElement.value = ''
    };

    this.uploader.onBuildItemForm = (item, form) => {
      form.append('job_id', this.job.id);
    };

    this.uploader.onCompleteItem = (item, response) => {

      try{
        let data = JSON.parse(response);
        this.job.file_entries.push(data.entry);
      }catch(e){
        console.log(e);
      }
    };

    this.uploader.onErrorItem = (item, response, status, headers) => {
      item.remove();
      console.log(response, status, headers);

      this.toast.show('You\'re file could not be uploaded.');
    };

    this.uploader.onProgressAll = (progress) => {
      this.renderer.setStyle(this.progressBarElRef.nativeElement, 'width', progress + '%');
    };

    this.uploader.onCompleteAll = () => {
      this.showSubmitModal();
    };
  }

  interpreterIsAttachmentOwner(file){
    return this.auth.user && file.user_id === this.auth.user.sub;
  }

  showSubmitModal() {
    let confirm = this.alertCtrl.create({
      title: this.translate.instant('job_attachments.submit_files'),
      message: this.translate.instant('job_attachments.submit_files_sub'),
      buttons: [
        this.translate.instant('global.cancel'),
        {
          text: this.translate.instant('global.submit'),
          handler: () => {
            confirm.dismiss()
              .then(() => this.submitFiles());
            return false;
          }
        }
      ]
    });
    confirm.present();
  }

  submitFiles() {
    this.jobService.submitFiles(this.job)
      .subscribe(success => this.toast.show(success.message));
  }

  showDeleteModal(entry) {
    let confirm = this.alertCtrl.create({
      title: this.translate.instant('job_attachments.delete_file'),
      buttons: [
        this.translate.instant('global.cancel'),
        {
          text: this.translate.instant('global.delete'),
          handler: () => {
            confirm.dismiss()
              .then(() => this.deleteFile(entry));
            return false;
          }
        }
      ]
    });
    confirm.present();
  }

  deleteFile(file){
    this.uploadService.deleteFile(file.id)
      .subscribe(success => {
        this.job.file_entries.splice(this.job.file_entries.indexOf(file), 1);
        this.toast.show(success.message)
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/uploader/job-attachments/job-attachments.component.ts